var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.225C16.295 24.225 14.6599 23.5534 13.4543 22.3578C12.2487 21.1623 11.5714 19.5408 11.5714 17.85C11.5714 16.1592 12.2487 14.5377 13.4543 13.3422C14.6599 12.1466 16.295 11.475 18 11.475C19.705 11.475 21.3401 12.1466 22.5457 13.3422C23.7513 14.5377 24.4286 16.1592 24.4286 17.85C24.4286 18.6872 24.2623 19.5162 23.9392 20.2896C23.6162 21.0631 23.1426 21.7658 22.5457 22.3578C21.9487 22.9498 21.2401 23.4194 20.4601 23.7397C19.6802 24.0601 18.8442 24.225 18 24.225ZM18 0C13.2261 0 8.64773 1.88062 5.27208 5.22814C1.89642 8.57567 0 13.1159 0 17.85C0 31.2375 18 51 18 51C18 51 36 31.2375 36 17.85C36 13.1159 34.1036 8.57567 30.7279 5.22814C27.3523 1.88062 22.7739 0 18 0Z",
    fill: "#FE8839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d9cfc6232f812ceee7ebf105e55653b7.svg";
export { ForwardRef as ReactComponent };